module.exports = __webpack_public_path__ + "img/salary_chart.3e5ee6a7.svg";